<template>
  <div class="form-container">
    <h2 class="form-title">{{ editing ? 'Editar Personal' : 'Agregar Personal' }}</h2>
    <form @submit.prevent="onSave">
      <div class="form-grid">
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre</label>
          <input type="text" id="nombre" v-model="localForm.nombre" class="form-control" placeholder="Ingrese el nombre"
            required />
        </div>
        <div class="mb-3">
          <label for="apellido" class="form-label">Apellido</label>
          <input type="text" id="apellido" v-model="localForm.apellido" class="form-control"
            placeholder="Ingrese el apellido" required />
        </div>
        <div class="mb-3">
          <label for="email" class="form-label">Email</label>
          <input type="email" id="email" v-model="localForm.email" class="form-control" placeholder="Ingrese el email"
            required />
        </div>
        <div class="mb-3">
          <label for="telefono" class="form-label">Teléfono</label>
          <input type="tel" id="telefono" class="form-control" pattern="[0-9+\(\)\s\-]{6,20}"
            inputmode="tel" placeholder="Ej: +54 9 11 1234 5678"
             v-model="localForm.telefono" />
        </div>
        <div class="mb-3">
          <label for="rol" class="form-label">Rol</label>
          <select id="rol" v-model="localForm.rol" class="form-select" required>
            <option value="" disabled>Seleccione un rol</option>
            <option v-for="categoria in categoriasPersonal" :key="categoria.tipo" :value="categoria.tipo">
              {{ categoria.descripcion }}
            </option>
          </select>
        </div>
        <div class="mb-3">
          <label for="estado" class="form-label">Estado</label>
          <select id="estado" v-model="localForm.estado" class="form-select" required>
            <option value="" disabled>Seleccione un estado</option>
            <option v-for="estado in estadosPersonal" :key="estado.tipo" :value="estado.tipo">
              {{ estado.descripcion }}
            </option>
          </select>
        </div>
        <div class="mb-3" v-if="!editing">
          <label for="legajo" class="form-label">Legajo</label>
          <div class="legajo-group">
            <input type="text" id="legajo" v-model="localForm.legajo" class="form-control"
              placeholder="Ingrese el legajo" required disabled />
            <button type="button" class="btn btn-primary btn-sm" @click="generarLegajo">Generar</button>
          </div>
          <div class="alert alert-warning mt-2" role="alert">
            El legajo no se podrá editar una vez creado el personal.
          </div>
        </div>
        <div class="mb-3">
          <label for="comentarios" class="form-label">Comentarios</label>
          <textarea id="comentarios" v-model="localForm.comentarios" class="form-control"
            placeholder="Ingrese comentarios (opcional)"></textarea>
        </div>
      </div>
      <div class="button-group">
        <button type="submit" class="btn btn-success">
          {{ editing ? 'Actualizar' : 'Guardar' }}
        </button>
        <button type="button" class="btn btn-secondary" @click="$emit('cancel-edit')">
          Cancelar
        </button>
      </div>
    </form>
  </div>
</template>


<style scoped>
.form-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
}

.form-title {
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 30px;
  text-align: center;
  color: #333333;
}

.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.mb-3 label {
  font-weight: 600;
  color: #555555;
}

.form-control,
.form-select {
  border-radius: 6px;
  padding: 10px;
  font-size: 1rem;
  border: 1px solid #ccc;
}

.form-control:focus,
.form-select:focus {
  outline: none;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
  border-color: var(--app-primary);
}

.legajo-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.alert-warning {
  font-size: 0.9rem;
}

.button-group {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
}

.btn {
  padding: 10px 20px;
  font-size: 1rem;
  border-radius: 6px;
}

.btn-success {
  background-color: #28a745;
  border-color: #28a745;
  color: white;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn-success:hover {
  background-color: #218838;
}

.btn-secondary:hover {
  background-color: #5a6268;
}
</style>

<script>
import axios from "@/axios";

export default {
  props: {
    form: {
      type: Object,
      required: true,
    },
    editing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localForm: { ...this.form }, // Copia local para edición
      categoriasPersonal: [], // Categorías para el combo box
      estadosPersonal: [], // Estados para el combo box
    };
  },
  watch: {
    form: {
      handler(newForm) {
        this.localForm = { ...newForm };
      },
      deep: true,
    },
  },
  methods: {
    onSave() {
      this.$emit("save-personal", { ...this.localForm });
    },
    fetchCategoriasPersonal() {
      axios
        .get("/api/constantes/tipos_de_rol_de_personal")
        .then((response) => {
          this.categoriasPersonal = response.data;
        })
        .catch((error) => {
          console.error("Error al cargar categorías de personal:", error);
        });
    },
    fetchEstadosPersonal() {
      axios
        .get("/api/constantes/estados_de_personal")
        .then((response) => {
          this.estadosPersonal = response.data;
        })
        .catch((error) => {
          console.error("Error al cargar estados de personal:", error);
        });
    },
    generarLegajo() {
      // llamar a la api de personal para generar un legajo
      axios
        .get("/api/personal_generar_legajo")
        .then((response) => {
          this.localForm.legajo = response.data.legajo;
        })
        .catch((error) => {
          console.error("Error al generar legajo:", error);
        });
    },
  },
  created() {
    this.fetchCategoriasPersonal();
    this.fetchEstadosPersonal();

    //si no esta editando genero un legajo
    if (!this.editing) {
      this.generarLegajo();
    }
  },
};
</script>
